import { useNavigate } from "react-router-dom";
import { AppBar } from "@/components/AppBar";
import { StepIndicator } from "@/components/StepIndicator";
import { SchoolLogoHero } from "@/components/schools/SchoolLogo";
import { SCHOOL_CARDS } from "@/data/schools";
import type { SchoolId } from "@/types/navigation";

export function SchoolsPage() {
  const navigate = useNavigate();

  const pick = (school: SchoolId) => {
    navigate(`/identity?school=${school}`);
  };

  return (
    <>
      <AppBar title="选择学校" showBack />
      <StepIndicator current={1} />
      <main className="pb-10">
        <div className="px-5 pb-5 pt-4">
          <h1 className="text-[30px] font-bold leading-tight tracking-tight text-ink-900">
            选择你的目标学校
          </h1>
          <p className="mt-3 text-sm leading-[1.7] text-ink-600">
            每个学校周边的住房选择都不一样。点选你的学校,我们给你定制攻略。
          </p>
        </div>

        <ul className="flex flex-col gap-4 px-4">
          {SCHOOL_CARDS.map((s) => (
            <li key={s.id}>
              <button
                type="button"
                onClick={() => pick(s.id)}
                className="w-full overflow-hidden rounded-xl bg-paper text-left shadow-card active:scale-[0.99]"
              >
                <div className="relative">
                  <SchoolLogoHero schoolId={s.id} alt={s.zh} />
                  <span className="absolute right-3.5 top-3.5 rounded-pill bg-white/90 px-3 py-1 text-[11.5px] font-bold tracking-wide text-ink-900 backdrop-blur-sm">
                    {s.abbrev}
                  </span>
                </div>
                <div className="px-[18px] pb-[18px] pt-4">
                  <p className="text-[17px] font-bold tracking-tight text-ink-900">
                    {s.zh}
                  </p>
                  <p className="mb-2.5 mt-0.5 text-[11.5px] tracking-wide text-ink-400">
                    {s.en}
                  </p>
                  <p className="mb-3.5 text-[13px] leading-snug text-ink-600">
                    {s.blurb}
                  </p>
                  <div className="flex items-center justify-between gap-3 border-t border-[var(--line-soft)] pt-3">
                    <span className="inline-flex min-w-0 items-center gap-1 text-xs font-medium text-ink-600">
                      <LocationIcon />
                      <span className="min-w-0">{s.area}</span>
                    </span>
                    <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-[12.5px] font-semibold text-coral-700">
                      查看攻略
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
                        <path
                          d="M2 6h8M7 3l3 3-3 3"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </button>
            </li>
          ))}

          <li
            className="mt-1 flex items-center gap-4 rounded-xl border border-dashed border-ink-200 px-5 py-5 opacity-70"
            aria-disabled
          >
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-dashed border-ink-300 text-ink-300">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
                <path
                  d="M11 4v14M4 11h14"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div>
              <p className="text-[15px] font-bold tracking-tight text-ink-600">
                更多学校即将上线
              </p>
              <p className="mt-1 text-xs text-ink-400">
                SUTD / SIM 等持续筹备中
              </p>
            </div>
          </li>
        </ul>
      </main>
    </>
  );
}

function LocationIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden>
      <path
        d="M5.5 1C3.5 1 2 2.5 2 4.5C2 7 5.5 10 5.5 10S9 7 9 4.5C9 2.5 7.5 1 5.5 1Z"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
      />
      <circle cx="5.5" cy="4.5" r="1.2" fill="currentColor" />
    </svg>
  );
}
